<template> 
  <div id="category-shows-list" v-if="showsList">
    <div class="row align-center medium-collapse small-uncollapse xsmall-collapse">
      <div class="xxlarge-10 medium-12 columns">
        <div v-for="show in showsList" class="show-list-item">
          <h2 class="title-date" :class="['date-' + show.date]">{{show.date}}</h2>
          <div class="row xxlarge-up-3 small-up-2 xsmall-up-1 xsmall-collapse">
            <div class="column" v-for="item in show.posts" v-parallax="0.01">
              <router-link :to="`/exposicao/${item.exposicao_slug}`">
                <img :data-url="item.exposicao_main_image.sizes['product-thumb-retina']" v-bind:alt="item.exposicao_title" v-lazyload>
                <h3>{{item.exposicao_title}}</h3>
                <h4 v-if="item.exposicao_main_author">{{item.exposicao_main_author}}</h4>
                <h5>{{item.exposicao_start_date}}</h5>
              </router-link>
            </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>    

<script>
export default {
  name: 'categoryShowsList',
  computed: {
   showsList() {
    return this.$store.getters.getDateShowsByCategory(this.$route.params.slug);
   }
 }
}
</script>
<!-- styling for the component -->
<style lang="scss">

#category-shows-list {
  margin: 160px 0;

  .show-list-item {
    margin-bottom: 125px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  h2 {
    font-family: 'Libre Baskerville';
    @include responsive-font-size(55px);
    line-height: 1;
    color: rgba(0,0,0,.3);
    margin-bottom: 30px;
  }

  h3 {
    font-family: 'Libre Baskerville';
    @include responsive-font-size(26px);
    text-transform: initial;
    line-height: 1.35;
    letter-spacing: -0.25px;
    margin: 20px 0 5px;
  }

  h4 {
    @include responsive-font-size(14px);
    font-family: 'Libre Baskerville';
    letter-spacing: 0;
    line-height: 1.3;
    margin-bottom: 15px;
    text-transform: none;
  }

  h5 {
    font-family: 'TT Norms';
    @include responsive-font-size(13px);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(0,0,0,.3);
    margin-top: 10px;
  }

  img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 250px;
    width: 100%;
  }
}

@include max-screen($medium) {
  #category-shows-list {
    padding-left: 85px;
    padding-right: 85px;

    img {
      height: 200px;
    }
  }
}

@include max-screen($small) {
  #category-shows-list {
    margin: 100px 0;
  }
}

@include max-screen($small) {
  #category-shows-list {
    padding-left: 50px;
    padding-right: 50px;
    margin-bottom: 80px;

    .row .row { margin: 0; }

    .show-list-item {
      .column {
        margin-bottom: 60px;

        &:last-child { margin-bottom: 0; }
      }
    }
  }
}

@include max-screen($xxsmall) {
  #category-shows-list {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 80px;

    .show-list-item {
      margin-bottom: 80px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/categoryShowsList.vue